// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__OkfbO","betAmount":"styles_betAmount__WEpOx","diceSubmitAutoWrap":"styles_diceSubmitAutoWrap__CyZ3O"};